
import { ReactNode } from 'react';
import { ErrorBoundary } from '@/components/ui/error-boundary';
import { SidebarGroup, SidebarGroupContent, SidebarGroupLabel, SidebarMenu } from '@/components/ui/sidebar';
import { useSidebar } from '@/components/ui/sidebar';

interface NavGroupProps {
  label: string;
  children: ReactNode;
  errorBoundaryName: string;
}

const NavGroup = ({ label, children, errorBoundaryName }: NavGroupProps) => {
  const { state } = useSidebar();
  const isCollapsed = state === 'collapsed';

  return (
    <SidebarGroup>
      {!isCollapsed && <SidebarGroupLabel>{label}</SidebarGroupLabel>}
      <SidebarGroupContent>
        <ErrorBoundary 
          fallback={<div className="p-2 text-sidebar-foreground text-xs">Erro ao carregar menu</div>}
          componentName={errorBoundaryName}
        >
          <SidebarMenu>
            {children}
          </SidebarMenu>
        </ErrorBoundary>
      </SidebarGroupContent>
    </SidebarGroup>
  );
};

export default NavGroup;
